/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { adminOpenRouterKeysGetKeyUsage } from "../funcs/adminOpenRouterKeysGetKeyUsage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetKeyUsageResponseBody } from "../models/components/getkeyusageresponsebody.js";
import {
  GetAdminOpenRouterKeyUsageRequest,
  GetAdminOpenRouterKeyUsageSecurity,
  KeyType,
} from "../models/operations/getadminopenrouterkeyusage.js";
import { unwrapAsync } from "../types/fp.js";
export type AdminOpenRouterKeyUsageQueryData = GetKeyUsageResponseBody;

export function prefetchAdminOpenRouterKeyUsage(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetAdminOpenRouterKeyUsageRequest,
  security?: GetAdminOpenRouterKeyUsageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAdminOpenRouterKeyUsageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAdminOpenRouterKeyUsageQuery(
  client$: GramCore,
  request: GetAdminOpenRouterKeyUsageRequest,
  security?: GetAdminOpenRouterKeyUsageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AdminOpenRouterKeyUsageQueryData>;
} {
  return {
    queryKey: queryKeyAdminOpenRouterKeyUsage({
      organizationId: request.organizationId,
      keyType: request.keyType,
      gramSession: request.gramSession,
    }),
    queryFn: async function adminOpenRouterKeyUsageQueryFn(
      ctx,
    ): Promise<AdminOpenRouterKeyUsageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(adminOpenRouterKeysGetKeyUsage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAdminOpenRouterKeyUsage(
  parameters: {
    organizationId: string;
    keyType: KeyType;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "adminOpenRouterKeys", "getKeyUsage", parameters];
}
